// BookingForm.js
import React, { useState } from 'react';
import './App.css';

function BookingForm() {
  const [formData, setFormData] = useState({
    artist: '',
    date: '',
    location: '',
    venue: '',
    promoter: '',
    floor: '',
    floorCapacity: '',
    totalCapacity: '',
    ticketPrice: '',
    feeOffer: '',
    lineup: '',
    email: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(false);

    try {
      const response = await fetch('https://formspree.io/f/mrblpeqq', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(e.target),
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    }
  };

  if (submitted) {
    return <p className="thank-you">Thank you for your booking inquiry. We'll be in touch soon.</p>;
  }

  return (
    <form className="booking-form" onSubmit={handleSubmit}>
      {error && <p className="error-message">Something went wrong. Please try again later.</p>}


      <label className="form-group">
        <span>Artist Request</span>
        <select name="artist" className="custom-dropdown input-field" value={formData.artist} onChange={handleChange} required>
          <option value="">Select an artist</option>
          <option value="Alexa Fluor">Alexa Fluor</option>
          <option value="Carotin">Carotin</option>
          <option value="ELOISA">ELOISA</option>
          <option value="Gianni">Gianni</option>
          <option value="MAUDUX">MAUDUX</option>
          <option value="Melanchromie">Melanchromie</option>
          <option value="Millie Forsberg">Millie Forsberg</option>
          <option value="SHANIXX">SHANIXX</option>
        </select>
      </label>

      <label className="form-group">
        <span>Your Email</span>
        <input type="email" name="email" className="input-field" value={formData.email} onChange={handleChange} required />
      </label>

      <div className="form-row">
        <label className="form-group">
          <span>Event Date</span>
          <input type="text" name="date" className="input-field" value={formData.date} onChange={handleChange} placeholder="DD / MM / YY" required />
        </label>

        <label className="form-group">
          <span>City</span>
          <input type="text" name="location" className="input-field" value={formData.location} onChange={handleChange} required />
        </label>
      </div>

      <div className="form-row">
        <label className="form-group">
          <span>Venue</span>
          <input type="text" name="venue" className="input-field" value={formData.venue} onChange={handleChange} />
        </label>

        <label className="form-group">
          <span>Promoter</span>
          <input type="text" name="promoter" className="input-field" value={formData.promoter} onChange={handleChange} />
        </label>
      </div>

      <label className="form-group">
        <span>Message</span>
        <textarea name="message" className="input-field" value={formData.message} onChange={handleChange} />
      </label>

      <input 
        type="hidden" 
        name="subject" 
        value="REQUEST: {{artist}} / {{date}} / {{location}} / {{promoter}}" 
     />

      <button type="submit">SEND BOOKING REQUEST</button>
    </form>
  );
}

export default BookingForm;
